import miniCardSvg from '../../../assets/images/mini-card.svg';
import { cn } from '../../../utils/cn';

type MiniCardProps = {
  className?: string;
};

/**
 * A small card icon component used in table rows to represent a virtual card.
 * Displays a stylized credit card with yellow gradient and noise texture.
 *
 * @param props.className - Optional additional CSS classes
 *
 * @example
 * ```tsx
 * <MiniCard />
 * ```
 */
export const MiniCard = ({ className }: MiniCardProps) => {
  return <img src={miniCardSvg} alt="" className={cn('h-7 w-10 shrink-0', className)} />;
};
